import { GITHUB_ISSUE_URL } from "../config/api";
import { authHeader } from "./apiToken";

// Asks the server to copy a saved Help report to a GitHub issue. The server builds the issue from the stored row,
// so only the id is sent. Never throws: the report is already saved, and a failure here is only logged.
export async function copyFeedbackToGitHub(feedbackId) {
  const id = Number(feedbackId);
  if (!GITHUB_ISSUE_URL || !Number.isInteger(id) || id <= 0) return null;
  try {
    const auth = await authHeader();
    const res = await fetch(GITHUB_ISSUE_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...auth },
      body: JSON.stringify({ feedback_id: id }),
    });
    if (!res.ok) { console.warn(`[Help] GitHub copy skipped (${res.status})`); return null; }
    return await res.json();
  } catch (err) {
    console.warn("[Help] GitHub copy skipped:", err?.message || err);
    return null;
  }
}
